import { createFileRoute } from "@tanstack/react-router";
import JobApplicationsActivitiesPage from "./-pages/activitiesPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/activities")({
  component: Component,
});

function Component() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Applications Activities", link: `/${datasetSlug}/data/applications/activities` }]);
  return <JobApplicationsActivitiesPage />;
}
